module.exports = __webpack_public_path__ + "img/facebook.cc8f30b5.svg";